import {LoadingStatus} from "../../../models/FormLoadingStatus";
const {LOADING, LOADED, TIME_OUT, NET_ERROR, ERROR} = LoadingStatus;

export class CoursLoadingStatus {
  places:  LoadingStatus = LOADED;
  courses:  LoadingStatus = LOADED;
  courseNames:  LoadingStatus = LOADED;
}
